




































import { Vue, Component, Prop } from "vue-property-decorator";
import {
  Employee as IEmployee,
  LearningRequest as ILearningRequest
} from "@/api/models";
import { getCurrentCompanyId } from "@/plugins/roles";

@Component
export default class ManagerBlock extends Vue {
  @Prop() employeeList!: Array<IEmployee>;
  @Prop() requests!: Array<ILearningRequest>;
  @Prop() isGetEmployeeSpinner!: boolean;
  showSpinner: boolean = false;
  limit: number = 1000;
  requestCount!: number;

  data() {
    return {
      requestCount: undefined
    };
  }

  getPriceByManager(managerId: string): number {
    const requestsByManagerId = this.requests
      ?.filter(el => el.status === "completed")
      ?.filter(el => el.responsibleId === managerId);
    return requestsByManagerId.reduce((a, b) => a + b.price, 0);
  }

  getClosedLearningRequest(managerId: string) {
    return this.requests
      ?.filter(el => el.status === "completed")
      ?.filter(el => el.responsibleId === managerId).length;
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }
}
